import React from "react"
import "./layout.css"

export default ({ children }) => <div>{children}</div>